import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AppLayout } from './components/layout/AppLayout';
import { ToastProvider } from './components/ui/Toast';
import { Dashboard } from './pages/Dashboard';
import { Users } from './pages/users/Users';
import { Customers } from './pages/customers/Customers';
import { Reports } from './pages/reports/Reports';
import { Branches } from './pages/Branches';
import { Login } from './pages/auth/Login';
import { Refills } from './pages/refills/Refills';
import { Referrals } from './pages/referrals/Referrals';
import { Inventory } from './pages/inventory/Inventory';
import { RefillsHistory } from './pages/history/RefillsHistory';
import { ReferralsHistory } from './pages/history/ReferralsHistory';
import { Settings } from './pages/Settings';
import { useAuthStore } from './stores/authStore';
function ProtectedRoute({
  children
}: {
  children: React.ReactNode;
}) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);
  if (!isAuthenticated) {
    return <Navigate to="/login" replace data-id="element-0" />;
  }
  return <>{children}</>;
}
export function App() {
  return <ToastProvider data-id="element-1">
      <Router data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/login" element={<Login data-id="element-5" />} data-id="element-4" />
          <Route path="/*" element={<ProtectedRoute data-id="element-7">
                <AppLayout data-id="element-8">
                  <Routes data-id="element-9">
                    <Route path="/" element={<Dashboard data-id="element-11" />} data-id="element-10" />
                    <Route path="/users" element={<Users data-id="element-13" />} data-id="element-12" />
                    <Route path="/customers" element={<Customers data-id="element-15" />} data-id="element-14" />
                    <Route path="/reports" element={<Reports data-id="element-17" />} data-id="element-16" />
                    <Route path="/branches" element={<Branches data-id="element-19" />} data-id="element-18" />
                    <Route path="/refills" element={<Refills data-id="element-21" />} data-id="element-20" />
                    <Route path="/referrals" element={<Referrals data-id="element-23" />} data-id="element-22" />
                    <Route path="/history/refills" element={<RefillsHistory data-id="element-25" />} data-id="element-24" />
                    <Route path="/history/referrals" element={<ReferralsHistory data-id="element-27" />} data-id="element-26" />
                    <Route path="/inventory" element={<Inventory data-id="element-29" />} data-id="element-28" />
                    <Route path="/settings" element={<Settings data-id="element-31" />} data-id="element-30" />
                  </Routes>
                </AppLayout>
              </ProtectedRoute>} data-id="element-6" />
        </Routes>
      </Router>
    </ToastProvider>;
}